import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { AppStoreProvider, useAppStore } from '../../stores';
import { OutputPreviewContainer } from '../../components';
import { TabModel } from '../../../common/types/TabModel';
import './DataCrafterAppOutputPreviewScreen.less';

const DataCrafterAppOutputPreviewScreen: React.FC = () => {
    const [sessionTab, setSessionTab] = React.useState<TabModel | undefined>(undefined);

    React.useEffect(() => {
        const tab = localStorage.getItem('dataCrafterSessionTab');
        document.body.classList.add('no-menu');
        document.body.classList.add('data-crafter-preview');
        if (tab) {
            setSessionTab(JSON.parse(tab) as TabModel);
            localStorage.removeItem('dataCrafterSessionTab');
        }
    }, []);

    if (!sessionTab) {
        return <div>No session tab found</div>;
    }

    return (
        <AppStoreProvider tab={sessionTab}>
            <PreviewInitializer />
            <OutputPreviewContainer
                hidePopoutButton
                documentPreviewStyle={{ width: '100%', height: 'calc(100vh - 300px)' }}
            />
        </AppStoreProvider>
    );
};

const PreviewInitializer: React.FC = () => {
    const appStore = useAppStore();

    const { sessionStore } = appStore;

    React.useEffect(() => {
        sessionStore.initialize();
        sessionStore.getChildSessions();
    }, [sessionStore]);

    return null;
};

export default observer(DataCrafterAppOutputPreviewScreen);
